// ----------------------------------------------------------------------

const account = {
  displayName: 'MyPrimeRenov',
  email: 'contact@myprimerenov.fr',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
